import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportAddressLookup } from 'dashboard/models/report/address-lookup';

interface AddressLookupProps {
  report: ReportAddressLookup;
  isRedacted: boolean;
}

export const AddressLookup = ({ report, isRedacted }: AddressLookupProps) => {
  const {
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
  } = report.attributes;

  return (
    <AttributeGrid>
      <AttributeItem
        title='Address'
        value={
          <p>
            {addressStreet1}
            <br />
            {addressStreet2 && (
              <>
                {addressStreet2} <br />
              </>
            )}
            {addressCity}, {addressSubdivision}, {addressPostalCode}
          </p>
        }
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-address-lookup__address'
      />
    </AttributeGrid>
  );
};
